import styled from "styled-components";
import BeerGIF from "../../assets/loading.gif";
import { colors } from "../../colors";

export const BeerGIFLoader = styled.img.attrs({ src: BeerGIF })`
  height: ${({ size }) => size || 200}px;
  color: ${colors.secondary};
`;
